const TEST_ENVIRONMENTS = ['development', 'staging', 'preview'] as const;

function isTestEnvironment(environment: string): boolean {
  return (TEST_ENVIRONMENTS as readonly string[]).includes(environment);
}

/**
 * Bold red line across the header, under its controls, on local, staging
 * and preview. Work done there is not kept: a re-seed, a clone or a reset
 * replaces it. Production shows nothing, and so does an unrecognised value, so
 * a typo in APP_ENVIRONMENT never puts it on production.
 */
export function TestInstanceNotice({ environment }: { environment: string }) {
  if (!isTestEnvironment(environment)) return null;
  return (
    <span className="text-lg font-bold text-red-600">
      This instance is for testing only. Any changes will not be kept.
    </span>
  );
}
